// src/App.jsx
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from 'antd';
import Header from './components/Header';
import AppFooter from './components/Footer';
import Home from './pages/Home';
import Auth from './pages/Auth';
import PostCard from './pages/PostCard';
import PostDetail from './pages/PostDetail';
import WritePost from './pages/WritePost';
import Archive from './pages/Archive';
import About from './pages/About';
import NotFound from './pages/NotFound';

const { Content } = Layout;

function App() {
  return (
    <BrowserRouter>
      <Layout className="blog-layout">
        <Header />
        {/* 关键修改：为 Content 添加顶部内边距，防止被导航栏遮挡 */}
        <Content 
          className="blog-content" 
          style={{ 
            paddingTop: '64px', // 根据 Header 的实际高度调整（通常为 64px）
            minHeight: 'calc(100vh - 64px)', // 确保内容区域占满剩余视口高度
            backgroundColor: '#fff' // 可选的背景色，根据设计调整
          }}
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/postcard" element={<PostCard />} />
            <Route path="/post/:id" element={<PostDetail />} />
            <Route path="/write" element={<WritePost />} />
            {/* 编辑文章路由 */}
            <Route path="/write/:id" element={<WritePost />} />
            <Route path="/archive" element={<Archive />} />
            <Route path="/about" element={<About />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Content>
        <AppFooter />
      </Layout>
    </BrowserRouter>
  );
}

export default App;